import { PROFILE_IMAGE_PATH_PATTERN, PROFILE_IMAGE_SUFFIX_PATTERN } from '@/lib/utils/regex';

/**
 * Enhance Twitter profile image URLs to a higher resolution variant.
 *
 * Twitter serves profile images with suffixes like `_normal`, `_bigger`, `_mini`, or `_200x200`.
 * For crisp avatars on retina, prefer `_200x200` (or `_400x400` for larger displays).
 */
export function enhanceTwitterProfileImageUrl(url: string, size: '200x200' | '400x400' = '200x200'): string {
  if (typeof url !== 'string' || url.length === 0) return url;

  // Only transform known Twitter hosts/paths
  if (!url.includes('twimg.com')) return url;

  // Replace common size suffixes with the requested one, preserving file extension and query
  if (PROFILE_IMAGE_SUFFIX_PATTERN.test(url)) {
    return url.replace(PROFILE_IMAGE_SUFFIX_PATTERN, `_${size}$2$3`);
  }

  if (PROFILE_IMAGE_PATH_PATTERN.test(url)) {
    return url.replace(PROFILE_IMAGE_PATH_PATTERN, `$1_${size}$2$3`);
  }

  return url;
}
